module.exports = __webpack_public_path__ + "static/img/none.28effbe4.jpg";